module.exports = __webpack_public_path__ + "img/health-festival-2025.fe8b3646.jpg";